import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styles: []
})
export class AsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
